<template>
    <div class="pictureCom">
        <div :style="{
            'background': `url('${configImgUrl()}${config.borImg}')`,
            'opacity': config.opacity,
        }"></div>
    </div>
</template>

<script>
    /**
     @author xcf
     @date 2020/6/29 3:57 下午
     */
    export default {
        name: 'pictureComp',
        components: {},
        props: {
            id: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
             option: {
                type: Object,
                default: ''
            },
            trans: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {}
        },
        computed: {
             config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.option.setting.params;
                }
            },
        },
        methods: {},
        mounted() {
        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .pictureCom {
        > div {
            width: 100%;
            height: 100%;
            background-size: 100% 100% !important;
        }
    }
</style>
